import {AbstractService} from "@/services/AbstractService";
import {app} from "@/app";

export class Ping extends AbstractService {
    async handle() {

        // Calculate page load time.
        let delay: null|number = null;
        try{
            delay = (new Date()).getTime() - window.performance.timing.navigationStart
        } catch (error) {}


        // send
        const data = {
            event_name: 'DebugPing',
            pixel_id: app.configOption('pixelId'),
            payload: {
                url: {
                    landing: window.location.href,
                    referrer: window.document.referrer,
                },
                delay,
                user_agent: navigator.userAgent,
            },
        };

        const url = app.configOption('endpoint');
        await fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
        })
    }
}
